import { Reveal, SectionHead } from "../components/bits";
import { TESTIMONIALS } from "../data/content";

export const Proof = () => (
    <section data-testid="testimonials-section" className="py-20 lg:py-24">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
            <SectionHead eyebrow="Kind words" title="What clients say about working with us." align="center" />
            <div className="mt-12 grid gap-5 md:grid-cols-3">
                {TESTIMONIALS.map((t, i) => (
                    <Reveal key={t.name + i} delay={i * 0.12}>
                        <figure
                            data-testid={`testimonial-${i + 1}`}
                            className="card-lift relative h-full rounded-2xl border border-linen bg-ivory p-7"
                        >
                            <span className="pointer-events-none absolute -top-1 right-5 font-serif text-[92px] leading-none text-blush select-none">
                                ”
                            </span>
                            <span className="font-mono text-[9px] uppercase tracking-[0.24em] text-gold">
                                Testimonial {String(i + 1).padStart(2, "0")}
                            </span>
                            <blockquote className="mt-4 font-serif text-lg leading-relaxed text-ink">
                                “{t.quote}”
                            </blockquote>
                            <figcaption className="mt-6 border-t border-linen pt-4">
                                <div className="font-sans text-[13px] font-medium text-ink">{t.name}</div>
                                <div className="mt-0.5 font-mono text-[9px] uppercase tracking-[0.18em] text-faint">{t.role}</div>
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
